import React, { useState } from 'react';
import {
	InputAdornment,
	TextField,
	Button,
	CircularProgress,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/navigation';
import { searchMessages } from '@/redux/actions/message.actions';
import styled from '@emotion/styled';
import { Search } from '@mui/icons-material';

export const CssTextField = styled(TextField, {
	shouldForwardProp: (props) =>
		props !== 'focusColor' &&
		props !== 'startIcon' &&
		props !== 'thin' &&
		props !== 'inputAdornment',
})((p) => ({
	width: '100%',
	'& .MuiInputLabel-root': {
		fontWeight: 500,
		fontFamily: 'Poppins',
	},
	// input label when focused
	'& label.Mui-focused': {
		color: p.focusColor,
	},
	// focused color for input with variant='standard'
	'& .MuiInput-underline:after': {
		borderBottomColor: p.focusColor,
	},
	// focused color for input with variant='filled'
	'& .MuiFilledInput-underline:after': {
		borderBottomColor: p.focusColor,
	},
	// focused color for input with variant='outlined'
	'& .MuiOutlinedInput-root': {
		paddingLeft: p.startIcon ? '30px' : '25px !important',
		paddingRight: '10px !important',
		'&.Mui-focused fieldset': {
			borderColor: p.focusColor,
		},
		backgroundColor: '#ffffff',
		borderRadius: '14px',
		minHeight: '40px',
	},
	'& .MuiOutlinedInput-input': {
		fontSize: '16px',
		fontWeight: '400',
	},
	'& .MuiInputBase-input': {
		marginLeft: '-10px !important',
	},
	'& .MuiInputAdornment-root': {
		marginRight: '25px',
	},
}));

const SearchInput = ({ name, defaultValue, navigateToSearchPage, width }) => {
	const dispatch = useDispatch();
	const router = useRouter();

	const [inputValue, setInputValue] = useState(defaultValue || '');
	const messagesLoading = useSelector((state) => state.messageReducer.loading);

	const handleInputChange = (event) => setInputValue(event.target.value);

	const onFormSubmit = (e) => {
		e.preventDefault();
		if (navigateToSearchPage) router.push(`/search?query=${inputValue}`);
		else dispatch(searchMessages(inputValue));
	};

	return (
		<form
			onSubmit={onFormSubmit}
			className='w-full'
		>
			<CssTextField
				focusColor='#000000'
				id='outlined-basic'
				name={name}
				placeholder='Search by brand or keyword'
				variant='outlined'
				InputProps={{
					startAdornment: (
						<InputAdornment position='start'>
							<Search />
						</InputAdornment>
					),
					endAdornment: (
						<Button
							style={{
								backgroundColor: '#B332E6',
								color: '#ffffff',
								width: '100%',
								height: '100%',
								maxWidth: '64px',
								maxHeight: '40px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								position: 'relative',
								fontSize: '16px',
								'&:hover': { backgroundColor: '#B332E6' },
							}}
							sx={{
								backgroundColor: '#B332E6',
								color: '#ffffff',
								width: '100%',
								height: '100%',
								maxWidth: '64px',
								maxHeight: '40px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								position: 'relative',
								fontSize: '16px',
								'&:hover': { backgroundColor: '#B332E6' },
							}}
							onClick={() => {
								if (navigateToSearchPage) {
									router.push(`/search?query=${inputValue}`);
								} else {
									dispatch(searchMessages(inputValue));
								}
							}}
							disabled={messagesLoading}
							aria-label={messagesLoading ? 'Loading' : 'Search'}
						>
							<span
								style={{
									visibility: messagesLoading ? 'hidden' : 'visible',
									width: '100%',
									height: '100%',
									maxWidth: '25px',
									maxHeight: '28px',
								}}
							>
								Go
							</span>
							{messagesLoading && (
								<CircularProgress
									size={20}
									color='inherit'
									sx={{
										position: 'absolute',
									}}
									aria-label='Loading search results'
								/>
							)}
						</Button>
					),
				}}
				onChange={handleInputChange}
				value={inputValue}
				aria-label='Search input'
			/>
		</form>
	);
};

export default SearchInput;
